import React, { useState } from 'react';
import { useRsi } from '../hooks/useRsi';
import { ConfirmCloseAlert } from './Alerts/ConfirmCloseAlert';
import { styled, Dialog } from '@beeline.com/bp-design-system';
import { useUserEvent, UserEvents } from '../integrations/userEvents/useUserEvent';

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

export const ModalWrapper = ({ children, isOpen, onClose }: Props) => {
  const { rtl } = useRsi();
  const [showModal, setShowModal] = useState(false);
  const { track } = useUserEvent();

  return (
    <>
      <ConfirmCloseAlert
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={() => {
          track(UserEvents.importerEvents.EXIT);
          setShowModal(false);
          onClose();
        }}
      />
      <StyledDialog
        open={isOpen}
        onClose={() => setShowModal(true)}
        id="rsi"
        show={{
          closeButton: true
        }}
        fullScreen
      >
        <StyledContent dir={rtl ? 'rtl' : 'ltr'}>{children}</StyledContent>
      </StyledDialog>
    </>
  );
};

const StyledContent = styled('div')`
    display: grid;
    height: 100%;
    grid-template-rows: auto auto 1fr auto;
`;

const StyledDialog = styled(Dialog)`
    .MuiDialog-container {
        padding: ${({ theme }) => theme.spacingSize.xl}
    }

    .MuiDialogContent-root > div {
        height: 100%
    }

    .MuiDialogContent-root {
        // Padding required to cover tables with few and many columns.
        // Works in tandem with the max-width property set on the stepper.
        padding: 8px 0 24px 24px;
    }
`;
